import { IconCalendarDisplay } from "assets/svg";
import { DateTime } from "luxon";
import styled, { css } from "styled-components";

export const CalendarDisplay = ({
  date,
  className,
}: {
  date: DateTime;
  className?: string;
}) => {
  return (
    <CalendarWrapper className={className}>
      <DayOfWeek>{date.toFormat("ccc")}</DayOfWeek>
      <Day>{date.day}</Day>
      <Month>{date.toFormat("LLL")}</Month>
      <CalendarImage />
    </CalendarWrapper>
  );
};

const DayOfWeek = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 14.81cqw;
  font-weight: 700;
  letter-spacing: 0.93cqw;
  line-height: 16.67cqw;
  opacity: 0.6;
  text-transform: uppercase;
  margin: 0;
  margin-top: 20.37cqw;
`;

const Month = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 18.52cqw;
  font-weight: 700;
  letter-spacing: 0.56cqw;
  line-height: 18.52cqw;
  opacity: 0.85;
  text-transform: uppercase;
  margin: 0;
`;

const Day = styled.p`
  color: #e71f3d;
  font-family: "Poppins", sans-serif;
  font-size: 35.19cqw;
  font-weight: 700;
  line-height: 38.89cqw;
  text-transform: uppercase;
  margin: 0;
`;

const CalendarImage = styled(IconCalendarDisplay)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  position: relative;
  aspect-ratio: 54 / 57;
  width: 54px;
  height: 57px;
  margin-top: -3px;
  container-type: size;

  ${({ theme }) =>
    theme.custom &&
    css`
      ${Day}, svg {
        color: #ffffff;
      }
    `};

  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 42px;
    height: 44px;
    margin-top: -2px;
  }
`;
